import {
  SET_SEARCH_PENDING,
  GET_SEARCH_RESULTS,
  GET_CONFIRM_SEARCH_RESULTS,
  GET_TO_SHIP_SEARCH_RESULTS,
  GET_SHIPPED_SEARCH_RESULTS,
  GET_OPEN_SEARCH_RESULTS,
  GET_DELIVERED_SEARCH_RESULTS,
  GET_RETURNED_SEARCH_RESULTS,
  GET_CANCELED_SEARCH_RESULTS,
  GET_COMPLETED_SEARCH_RESULTS,
  SET_SEARCH_PARAM,
} from 'store/constants/action-types';

export const setSearchPendingStatus = (payload) => {
  return { type: SET_SEARCH_PENDING, payload: payload };
};

export const setSearchParamAction = (payload) => {
  return { type: SET_SEARCH_PARAM, payload: payload };
};

export const getSearchResultsAction = (searchParam, tab, view, page) => {
  const searching = view === 'Active Listings' ? null : tab;
  switch (searching) {
    case 'confirm':
      return { type: GET_CONFIRM_SEARCH_RESULTS, searchParam: searchParam, page: page };
    case 'toShip':
      return { type: GET_TO_SHIP_SEARCH_RESULTS, searchParam: searchParam, page: page };
    case 'shipped':
      return { type: GET_SHIPPED_SEARCH_RESULTS, searchParam: searchParam, page: page };
    case 'all':
      return view === 'Open'
        ? { type: GET_OPEN_SEARCH_RESULTS, searchParam: searchParam, page: page }
        : { type: GET_COMPLETED_SEARCH_RESULTS, searchParam: searchParam, page: page };
    case 'delivered':
      return { type: GET_DELIVERED_SEARCH_RESULTS, searchParam: searchParam, page: page };
    case 'returned':
      return { type: GET_RETURNED_SEARCH_RESULTS, searchParam: searchParam, page: page };
    case 'canceled':
      return { type: GET_CANCELED_SEARCH_RESULTS, searchParam: searchParam, page: page };
    default:
      return { type: GET_SEARCH_RESULTS, searchParam: searchParam, page: page };
  }
};
